// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1472":"b7cb5ad5dfdc9714","6012":"3003cedf4cbc841d"}[chunkId] + ".css";
};